import { useEffect } from 'react';

export const useInterval = (fn: () => void, interval: number) => {
  if (interval < 0) {
    throw new Error(`interval can't be less than 0, got: ${interval}`);
  }

  useEffect(() => {
    const intervalRef = setInterval(fn, interval);

    return () => clearInterval(intervalRef);
  }, [fn, interval]);
};
